export const environment = process.env.REACT_APP_ENVIRONMENT || "development";


export const URL = {
  development: "https://api.lms.embifi.in",
  production: "https://prod.api.lms.embifi.in",
};
